module.exports = __webpack_public_path__ + "img/rep-stefanie.ceee2a55.png";